import { useContext } from "react";
import { AppContext } from "../AppContext";

export default function Project() {
  const { data } = useContext(AppContext);

  return (
     <div id="pjoin">
      <img src={`/image/9.png`} className="pageTitle" />
      <div  className="pContent" >
        <div  className="building"> 建设中，敬请期待～ </div>   
      </div>
      
      
    </div>
  );
}